

export const overwriteRTEDefaultInternalEmbedConfig = (defaultConfig) => ({
    ...defaultConfig,
    metaBlock: []
})
